export const getTransformedPermissionList = (list) => {
    const transformedData = [];
    const depth1Map = new Map();
    // 구조 만들기
    list.forEach((item) => {
        let depth1 = depth1Map.get(item.depth1Code);
        if (!depth1) {
            depth1 = {
                depth1Code: item.depth1Code,
                depth1Name: item.depth1Name,
                depth2: [],
            };
            depth1Map.set(item.depth1Code, depth1);
            transformedData.push(depth1);
        }
        let depth2 = depth1.depth2.find((d2) => d2.item.depth2Code === item.depth2Code);
        // 허브에서 무분별하게 사용되고 있어서 일시적으로 숨김 한다.
        // 추후 권한을 명확히 하여 주석 해제 예정
        // 임시로 로컬에서만 열어둔다.
        // 20250102 윤태건
        // https://barogo.slack.com/archives/C01A1R67RFA/p1735625133223899
        if (window.location.host !== 'localhost:5090'
            && item.depth2Name === '허브선택') {
            return;
        }
        if (!depth2) {
            depth2 = {
                item,
                children: [],
            };
            depth1.depth2.push(depth2);
            return;
        }
        depth2.children.push({
            item,
        });
    });
    return transformedData;
};
